export class S3PresignedPost {
  constructor(
    readonly url: string,
    readonly fields: Record<string, string>,
    private readonly http: typeof fetch = window.fetch.bind(window),
  ) {}

  async upload(file: Blob): Promise<void> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(this.fields)) {
      formData.append(key, value);
    }
    formData.append('file', file);

    const response = await this.http(this.url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file: ${response.status}`);
    }
  }
}
